namespace $.$$ {

	type Cell_id = { row : number[] , col : number }
	type Relation_page = {
		dataset: string
		record: string
		parent_label?: string
		source?: { dataset: string, field: string, record: string }
		legacy_source?: { table: string, row: number, name: string }
	}

	export class $shm_hitalama_map_widget_float_table_form extends $.$shm_hitalama_map_widget_float_table_form {

		custom() {
			return ( this.table() as unknown as $shm_hitalama_map_widget_float_table ).table_custom()!
		}

		field_names(): string[] {
			return this.custom().input_field_names()
		}

		form_fields(): readonly ( any )[] {
			return this.field_names().map( name => this.Field( name ) )
		}

		field_name( name: string ) {
			return name
		}

		field_type( name: string ) {
			return this.custom().field_type( name )
		}
		field_link_options( name: string ) {
			return ( this.table() as $shm_hitalama_map_widget_float_table ).table_relation_options_for_name( name )
		}
		field_link_content( name: string, link: string ) {
			const custom = this.custom()
			const field = custom instanceof $shm_hitalama_map_widget_entity_table2_dataset ? custom.field( name ) : null
			if( !field ) return [ this.field_link_options( name )[ link ] ?? link ]
			return this.$.$shm_hitalama_map_widget_entity_table2_display_content(
				this.table().map(), this.table().widget().table(), this.table().widget(), this, field, link,
			)
		}
		override Atom_link( name: string ) {
			const relation = super.Atom_link( name )
			relation.item_content = ()=> this.field_link_content( name, relation.value() )
			relation.option_content = link => this.field_link_content( name, link )
			return relation
		}
		override List_link( name: string ) {
			const relation = super.List_link( name )
			relation.item_content = link => this.field_link_content( name, link )
			return relation
		}
		field_select_dictionary( name: string ) {
			return Object.fromEntries( ( this.table() as $shm_hitalama_map_widget_float_table )
				.table_select_options_for_name( name ).map( value => [ value, value ] ) )
		}
		field_relation_active( name: string ) {
			return ( this.table() as $shm_hitalama_map_widget_float_table ).table_form_relation_active( name )
		}
		@ $mol_action
		field_relation_open( name: string, link?: string ) {
			if( link === undefined ) return ''
			;( this.table() as $shm_hitalama_map_widget_float_table ).table_form_relation_open( name, link )
			return link
		}
		@ $mol_action
		field_relation_create( name: string, event?: Event ) {
			if( event === undefined ) return null
			;( this.table() as $shm_hitalama_map_widget_float_table ).table_form_relation_create( name )
			return event
		}

		field_relation_create_current( name: string ) {
			const page = ( this.table() as $shm_hitalama_map_widget_float_table ).table_relation_page_target( 0 )
			return !!page && !page.record && page.legacy_source?.name === name
		}
		field_list_value( name: string, next?: readonly string[] ) {
			const value = this.field_value( name, next )
			return Array.isArray( value ) ? value : []
		}
		field_number( name: string, next?: number ) {
			const value = this.field_value( name, next === undefined ? undefined : Number.isNaN( next ) ? '' : next )
			return value === '' || value == null ? NaN : Number( value )
		}

		field_bid( name: string ) {
			if( !this.custom().field_required( name ) ) return ''
			const value = this.field_type( name ) === 'file'
				? this.field_files( name ).length ? this.field_files( name ) : this.data_value( name )
				: this.field_value( name )
			if( Array.isArray( value ) ) return value.length ? '' : '*'
			return String( value ?? '' ).trim() ? '' : '*'
		}

		@ $mol_mem_key
		Content_by_type( name: string ) {
			return super.Content_by_type( name )
		}

		Field_content( name: string ) {
			const type = this.field_type( name )
			if( type === 'custom' ) return this.String( name )
			const content = this.Content_by_type( name )
			return content[ type as keyof typeof content ]
		}

		pb_map_id() {
			return this.table().map().link().toString()
		}

		pb_widget_id() {
			return this.table().widget().link_str()
		}

		@ $mol_mem_key
		data_value( name: string, next?: any ) {
			const table = this.table() as unknown as $shm_hitalama_map_widget_float_table
			return this.row_index() < 0
				? table.create_data_value( name, next )
				: table.edit_data_value( name, next )
		}

		@ $mol_mem_key
		field_value( name: string, next?: any ) {
			const type = this.field_type( name )
			if( type === 'file' ) {
				if( next === '' ) {
					this.field_files( name, [] )
					return this.data_value( name, '' )
				}
				const file = this.field_file( name )
				return this.data_value( name, file?.link().toString() )
			}
			if( type === 'file_pb' && next === '' ) return this.data_value( name, '' )

			const value = this.data_value( name, next )
			if( type === 'date' && next === undefined && typeof value === 'string' ) {
				const match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec( value )
				if( match ) return `${ match[3] }-${ match[2] }-${ match[1] }`
			}
			return value
		}

		@ $mol_mem_key
		field_file( name: string ) {
			const native = this.field_files( name )[0]
			if( !native ) return null
			const file = this.table().map().Files( null )?.make( null )
			file?.write( native )
			return file!
		}

		form_object() {
			return Object.fromEntries( this.field_names().map( ( name: string )=> {
				const value = this.field_value( name )
				if( this.field_type( name ) !== 'date' ) return [ name, value ]
				return [ name, value ? new $mol_time_moment( value ).toString( 'DD.MM.YYYY' ) : '' ]
			} ) )
		}

		@ $mol_action
		fields_clear() {
			this.field_names().forEach( ( name: string )=> {
				this.field_value( name, '' )
				if( this.field_type( name ) === 'file_pb' ) this.File_pb( name ).form_reset()
			} )
		}

		@ $mol_action
		clear() {
			this.fields_clear()
			this.submit_result( '' )
		}

		clear_button_visible() { return this.clear_asked() ? [] : [ this.Clear() ] }
		clear_confirm_visible() { return this.clear_asked() ? [ this.Clear_confirm(), this.Clear_cancel() ] : [] }

		@ $mol_action
		clear_ask( event?: Event ) {
			if( event ) this.clear_asked( true )
			return event ?? null
		}

		@ $mol_action
		clear_cancel( event?: Event ) {
			if( event ) this.clear_asked( false )
			return event ?? null
		}

		@ $mol_action
		clear_confirm( event?: Event ) {
			if( event ) {
				this.clear()
				this.clear_asked( false )
			}
			return event ?? null
		}

		@ $mol_action
		submit() {
			if( !this.submit_allowed() ) return
			const row_i = this.row_index()
			const table = this.table() as $shm_hitalama_map_widget_float_table
			if( row_i >= 0 ) {
				// File values are materialized lazily from the selected native File.
				// Existing rows otherwise close without ever reading the file field.
				for( const name of this.field_names() ) {
					if( this.field_type( name ) === 'file' ) this.field_value( name )
				}
				table.record_edit_complete( row_i )
				return
			}
			const message = table.record_submit( row_i, this.form_object() )
			this.fields_clear()
			this.submit_result( message )
		}

		submit_result_visible() {
			return this.submit_result() ? super.submit_result_visible() : []
		}

		@ $mol_action
		close( next?: Event ) {
			if( next === undefined ) return null
			;( this.table() as unknown as { form_close( row_i: number ): void } ).form_close( this.row_index() )
			return next
		}

	}

	export class $shm_hitalama_map_widget_float_table_link_list extends $.$shm_hitalama_map_widget_float_table_link_list {
		check_title( link: string ) {
			return this.table_relation().table_relation_options( this.cell_id() )[ link ] ?? link
		}
	}

	export class $shm_hitalama_map_widget_float_table_relation_form extends $shm_hitalama_map_widget_float_table_form {
		table_relation() { return this.table() as $shm_hitalama_map_widget_float_table }
		page_index() { return 0 }
		custom() { return this.table_relation().table_relation_page_dataset( this.page_index() )! }
		row_index() { return this.table_relation().table_relation_page_row_index( this.page_index() ) }
		title() { return this.table_relation().table_relation_page_title( this.page_index() ) }
		data_value( name: string, next?: any ) { return this.table_relation().table_relation_page_data_value( this.page_index(), name, next ) }
		field_link_options( name: string ) { return this.custom().field_link_options( name ) }
		field_select_dictionary( name: string ) {
			return Object.fromEntries( this.custom().field_select_options( name ).map( ( value: string )=> [ value, value ] ) )
		}
		field_relation_active( name: string ) {
			const target = this.table_relation().table_relation_page_target( this.page_index() + 1 )
			return target && this.custom().field_target_dataset( name )?.link().str === new $giper_baza_link( target.dataset ).str
				? target.record : ''
		}
		@ $mol_action
		field_relation_open( name: string, link?: string ) {
			if( link === undefined ) return ''
			this.table_relation().table_relation_open_field( this.custom().field( name ), link, this.page_index() )
			return link
		}
		@ $mol_action
		field_relation_create( name: string, event?: Event ) {
			if( event === undefined ) return null
			const field = this.custom().field( name )
			const record = this.table_relation().table_relation_page_record( this.page_index() )
			if( field && record ) this.table_relation().table_relation_create_record( this.page_index(), field, record )
			else $shm_hitalama_notifications.warning( 'Сначала сохраните запись' )
			return event
		}

		field_relation_create_current( name: string ) {
			const page = this.table_relation().table_relation_page_target( this.page_index() + 1 )
			return !!page && !page.record
				&& page.source?.field === this.custom().field( name )?.link().str
		}
		@ $mol_action
		submit() {
			if( !this.submit_allowed() ) return
			const page = this.table_relation().table_relation_page_target( this.page_index() )
			if( page?.source ) {
				if( !this.table_relation().table_relation_create_record_submit( this.page_index(), this.custom().object_current() ) ) return
				this.table_relation().table_relation_close_at( this.page_index() )
				$shm_hitalama_notifications.success( 'Запись создана' )
				return
			}
			if( !page?.record && this.table_relation().table_relation_create_source() ) {
				if( !this.table_relation().table_relation_create_submit( this.custom().object_current() ) ) return
				this.table_relation().table_relation_close_at( this.page_index() )
				$shm_hitalama_notifications.success( 'Запись создана' )
				return
			}
			this.table_relation().table_relation_close_at( this.page_index() )
			$shm_hitalama_notifications.success( 'Запись обновлена' )
		}
		@ $mol_action
		close( next?: Event ) {
			if( next === undefined ) return null
			this.table_relation().table_relation_close_at( this.page_index() )
			return next
		}
	}

	export class $shm_hitalama_map_widget_float_table extends $.$shm_hitalama_map_widget_float_table {

		table_self() {
			return this
		}

		related_table_title( dataset: $shm_hitalama_map_widget_entity_table2_dataset | null ) {
			if( !dataset ) return this.widget().title()
			return this.map().Widgets_list()?.remote_list().find( widget =>
				widget.type() === 'table2' && widget.Dataset()?.remote()?.link().str === dataset.link().str
			)?.title() || this.widget().title()
		}

		record_first_label( dataset: $shm_hitalama_map_widget_entity_table2_dataset | null,
			record: $shm_hitalama_map_widget_entity_table2_record | null | undefined ) {
			const field = dataset?.fields()[0]
			const value = field && record?.value( field )
			return value === null || value === undefined || value === '' ? '' : String( value )
		}

		controls() {
			return [ this.Table_content() ]
		}

		head_showed() {
			return !this.fullscreen() || !(
				this.create_open() || this.edit_row_index() >= 0 || this.table_relation_pages().length > 0
			)
		}

		table_custom() {
			return this.widget().table().form_custom()
		}

		fullsize_height() { return '100%' }

		fullscreen() {
			return this.$.$mol_state_arg.value( 'fullscreen_widget' ) === this.widget().link_str()
		}

		@ $mol_mem
		create_open( next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem
		edit_row_index( next?: number ) {
			return next ?? -1
		}

		@ $mol_mem
		create_record( next?: Record< string, any > ) {
			return next ?? {}
		}

		@ $mol_mem
		edit_record( next?: Record< string, any > ) {
			if( next !== undefined ) return next
			const source = this.table_custom()?.objects()[ this.edit_row_index() ] as Record< string, any > | undefined
			return { ...( source ?? {} ) }
		}

		@ $mol_mem
		table_editing( next?: boolean ) {
			return next ?? false
		}

		@ $mol_action
		table_edit_toggle( next?: Event ) {
			if( next === undefined ) return null
			if( !this.fullscreen() ) {
				this.widget().settings_widget_enabled( true )
				this.Map_page().go_to_widget( this.widget().settings_widget().link() )
				return next
			}
			const editing = !this.table_editing()
			this.column_editor_col( -1 )
			if( editing ) this.edit_row_index( -1 )
			this.table_editing( editing )
			return next
		}

		table_edit_active() {
			return this.fullscreen() && this.table_editing()
		}

		@ $mol_action
		table_edit_close( next?: Event ) {
			if( next === undefined ) return null
			this.table_editing( false )
			return next
		}

		table_editor_fields() {
			return [
				this.Table_schema_field(),
				this.Table_rows_limit_field(),
				this.Table_delete_rows(),
				this.Table_widths_field(),
				this.Table_visibility_field(),
			]
		}

		@ $mol_mem
		table_schema( next?: string ) {
			const custom = this.table_custom()
			if( !custom ) return ''
			if( next === undefined ) return custom.text()
			if( !custom.fields_mutable() ) return custom.text()
			return custom.text( next )
		}

		table_schema_enabled() {
			return this.table_custom()?.fields_mutable() ?? false
		}

		table_rows_limit( next?: number ) {
			return this.widget().table().rows_limit( next )
		}

		@ $mol_mem_key
		create_data_value( name: string, next?: any ) {
			const record = this.create_record()
			if( next === undefined ) return record[ name ] ?? ''
			this.create_record({ ... record, [ name ]: next })
			return next
		}

		@ $mol_mem_key
		edit_data_value( name: string, next?: any ) {
			const record = this.edit_record()
			if( next === undefined ) return record[ name ] ?? ''
			this.edit_record({ ... record, [ name ]: next })

			const row_i = this.edit_row_index()
			const custom = this.table_custom()
			if( row_i >= 0 && custom ) {
				const objects = [ ... custom.objects() ]
				const source = objects[ row_i ] as Record< string, any > | undefined
				const value = custom.field_type( name ) === 'date' && next
					? new $mol_time_moment( next ).toString( 'DD.MM.YYYY' )
					: next
				objects[ row_i ] = { ...( source ?? {} ), [ name ]: value }
				custom.objects( objects )
			}

			return next
		}

		edit_form_title() {
			return this.widget().title()
		}

		workspace_content() {
			if( !this.fullscreen() ) return [ this.Table_panel() ]
			if( this.column_editor_col() >= 0 && this.column_editor_fullscreen() ) return [ this.Column_editor() ]
			return [
				...( this.create_open() ? [ this.Create_panel() ] : [] ),
				this.Table_panel(),
				...( this.column_editor_col() >= 0 ? [ this.Column_editor() ]
					: this.table_editing() ? [ this.Table_editor_panel() ]
					: [
						...( this.edit_row_index() >= 0 ? [ this.Edit_panel() ] : [] ),
						...this.table_relation_pages().map( ( page, index )=> this.Table_relation_edit_panel( index ) ),
					] ),
			]
		}

		relation_stack_open() { return this.table_relation_pages().length > 0 }
		
		@ $mol_mem
		rows() {
			const table = this.widget().table()
			const all = table.table_rows() ?? []
			const visible = this.visible_data_indexes()
			const editable = Boolean( this.widget().table().form_custom() )
			return Object.fromEntries( this.page_indexes().map( index => [ index, [
				...( this.checkboxes_showed() ? [ false ] : [] ),
				index + 1,
				...visible.map( col => all[ index ][ col ] ),
				...( editable ? [ null ] : [] ),
			] ] ) )
		}

		page_count() {
			const limit = this.table_rows_limit()
			return limit ? Math.max( 1, Math.ceil( this.filtered_indexes().length / limit ) ) : 1
		}

		@ $mol_mem
		page_indexes() {
			const all = this.filtered_indexes(), limit = this.table_rows_limit()
			const offset = this.fullscreen() ? this.page_index() * limit : 0
			return limit ? all.slice( offset, offset + limit ) : all
		}

		table_row_ids() { return this.page_indexes().map( index => [ '', String( index ) ] ) }
		grid_cells( row: string[] ) { return this.col_ids().map( col => this.Cell({ row: row as any, col }) ) }
		override table_scroll_top( next?: number ) { return this.Table_scroll().scroll_top( next ) }
		override table_viewport_height() {
			this.Table_scroll().view_rect()
			return ( this.Table_scroll().dom_node() as HTMLElement ).clientHeight || Math.max( 40, this.height() - 40 )
		}
		table_header_height() {
			const head = this.Table().Head()
			head.view_rect()
			return ( head.dom_node() as HTMLElement ).offsetHeight || 40
		}

		@ $mol_mem
		selected_row( next = -1 ) { return next }
		row_selected( row: string[] ) { return Number( row[1] ) === this.selected_row() }

		@ $mol_mem
		search( next?: string ) {
			if( next !== undefined ) this.page_requested( 0 )
			return next ?? ''
		}

		@ $mol_mem
		search_opened( next?: boolean ) {
			return next ?? false
		}

		search_field_visible() {
			return this.search_opened() ? [ this.Search() ] : []
		}

		query_status_visible() {
			return this.search_opened() ? [ this.Query_status() ] : []
		}

		search_active() {
			return this.search_opened() || Boolean( this.search() )
		}

		@ $mol_action
		search_toggle( next?: Event ) {
			if( next === undefined ) return null
			const opened = !this.search_opened()
			this.search_opened( opened )
			if( opened ) this.Search().Query().focused( true )
			return next
		}

		search_debounce() { return 200 }

		@ $mol_mem
		search_debounced() {
			const query = this.search()
			if( query ) this.$.$mol_wait_timeout( this.search_debounce() )
			return query
		}

		@ $mol_mem_key
		filter_by_name( name: string ) {
			return $shm_hitalama_map_widget_float_table_filter.make({
				changed: () => { this.page_requested( 0 ) },
				kind: () => this.filter_kind( name ),
			})
		}
		@ $mol_mem_key
		filter_kind( name: string ) {
			const index = this.widget().table_head().indexOf( name )
			const type = this.widget().table_col_types()[ index ]
			if( type === 'file' || type === 'file_pb' ) return 'file'
			if( type === 'date' || type === 'number' ) return type
			if( type !== 'any' ) return 'text'
			const values = this.widget().table().table_rows().map( row => row[index] ).filter( value => value != null && value !== '' )
			return values.length && values.every( value => typeof value === 'number' ) ? 'number' : 'text'
		}
		Column_filter( col: number ) { return this.filter_by_name( this.col_settings_title( col ) ) }

		@ $mol_mem
		sort_state( next?: { name: string, direction: string } ) { return next ?? { name: '', direction: 'none' } }
		column_sort( col: number, next?: string ) {
			const name = this.col_settings_title( col )
			if( next !== undefined ) { this.sort_state({ name, direction: next }); this.page_requested( 0 ) }
			const state = this.sort_state()
			return state.name === name ? state.direction : 'none'
		}

		@ $mol_mem
		filtered_indexes() {
			const table = this.widget().table(), rows = table.table_rows(), head = this.widget().table_head()
			const needle = this.search_debounced().trim().toLocaleLowerCase( 'ru' )
			const indexes = rows.map( ( _, index ) => index ).filter( index => {
				const row = rows[index]
				return ( !needle || row.some( ( value: unknown, col: number ) => this.query_value( value, col ).toLocaleLowerCase( 'ru' ).includes( needle ) ) )
					&& head.every( ( name, col ) => this.filter_by_name( String( name ) ).matches( row[col] ) )
			} )
			const sort = this.sort_state(), col = head.indexOf( sort.name )
			if( col < 0 || sort.direction === 'none' ) return indexes
			const filter = this.filter_by_name( sort.name )
			return indexes.sort( ( a, b ) => {
				const left = filter.parse( rows[a][col] ), right = filter.parse( rows[b][col] )
				const missing = ( value: unknown ) => value === '' || typeof value === 'number' && Number.isNaN( value )
				if( missing( left ) !== missing( right ) ) return missing( left ) ? 1 : -1
				const order = typeof left === 'number' && typeof right === 'number' ? left - right : String( left ).localeCompare( String( right ), 'ru', { numeric: true } )
				return ( sort.direction === 'desc' ? -order : order ) || a - b
			} )
		}

		query_value( value: unknown, col: number ) {
			const text = String( value ?? '' ), type = this.widget().table_col_types()[col]
			if( type === 'atom_link' || type === 'list_link' ) {
				const name = this.table_custom()?.field_names()[ col ] ?? ''
				const options = this.table_relation_options_for_name( name )
				const links = Array.isArray( value ) ? value : value ? [ value ] : []
				return links.map( link => options[ String( link ) ] ?? String( link ) ).join( ', ' )
			}
			if( !text ) return ''
			if( type === 'date' ) return this.$.$shm_date.text( text )
			if( type === 'file' ) return this.$.$mol_error_fence(
				() => $giper_baza_glob.Pawn( new $giper_baza_link( text ), $shm_hitalama_file ).title(),
				() => '',
			)
			if( type === 'file_pb' ) return this.$.$mol_error_fence( () => {
				const parsed = this.$.$shm_hitalama_file_attach_pb_store.value_parse( text )
				return parsed ? decodeURIComponent( parsed.uri.pathname.split( '/' ).at( -1 ) ?? '' ) : ''
			}, () => '' )
			return text
		}

		active_filter_names() { return this.widget().table_head().map( String ).filter( name => this.filter_by_name( name ).mode() !== 'all' ) }
		active_filter_text() { return `Фильтры: ${ this.active_filter_names().join( ', ' ) }` }
		active_filter_content() { return this.active_filter_names().length ? [ this.Active_filters() ] : [] }
		reset_visible() { return this.search() || this.active_filter_names().length || this.sort_state().direction !== 'none' ? [ this.Reset_filters() ] : [] }
		@ $mol_action
		reset_filters() {
			this.search( '' )
			for( const name of this.widget().table_head() ) this.filter_by_name( String( name ) ).mode( 'all' )
			this.sort_state({ name: '', direction: 'none' })
			this.page_requested( 0 )
		}
		query_status() {
			const all = this.widget().table().table_rows().length
			const found = `Найдено: ${ this.filtered_indexes().length } из ${ all }`
			if( !this.checkboxes_showed() ) return found
			const checks = this.widget().table().Rows_checked()?.val() ?? {}
			const selected = Object.entries( checks ).filter( ([ key, value ]) => value && Number( key ) < all ).length
			return `${ found } · Выбрано: ${ selected }`
		}
		empty_message() { return this.widget().table().table_rows().length ? 'По условиям поиска ничего не найдено' : 'Таблица пустая' }
		empty_content() {
			if( this.filtered_indexes().length ) return []
			return [ this.Empty() ]
		}
		col_indicators( col: number ) {
			const sort = this.column_sort( col )
			return `${ sort === 'asc' ? '↑' : sort === 'desc' ? '↓' : '' }${ this.Column_filter( col ).mode() !== 'all' ? ' ⏷' : '' }`
		}
		col_indicators_hint( col: number ) {
			return [ this.column_sort( col ) === 'asc' ? 'По возрастанию' : this.column_sort( col ) === 'desc' ? 'По убыванию' : '', this.Column_filter( col ).mode() !== 'all' ? 'Фильтр активен' : '', this.column_pinned( col ) ? 'Столбец закреплён' : '' ].filter( Boolean ).join( '. ' )
		}
		column_pinned( col: number, next?: boolean ) {
			const table = this.widget().table(), name = this.col_settings_title( col ), pinned = table.cols_pinned()
			if( next === undefined ) return pinned.includes( name )
			if( next && !Number.isFinite( this.col_width( col ) ) ) this.col_width( col, 180 )
			this.Col_settings( col ).showed( false )
			table.cols_pinned( next ? [ ...new Set( [ ...pinned, name ] ) ] : pinned.filter( value => value !== name ) )
			return next
		}
		@ $mol_action
		column_move( col: number, direction: number ) {
			const table = this.widget().table(), head = this.widget().table_head().map( String )
			const order = [ ...new Set( [ ...table.cols_order(), ...head ] ) ].filter( name => head.includes( name ) )
			const from = order.indexOf( this.col_settings_title( col ) ), to = from + direction
			if( from < 0 || to < 0 || to >= order.length ) return
			;[ order[from], order[to] ] = [ order[to], order[from] ]
			this.Col_settings( col ).showed( false )
			table.cols_order( order )
		}
		@ $mol_action
		column_left( col: number ) { this.column_move( col, -1 ) }
		@ $mol_action
		column_right( col: number ) { this.column_move( col, 1 ) }

		column_pinned_edge( col: number ) {
			const pinned = this.col_ids().filter( current => this.data_col_index( current ) >= 0 && this.column_pinned( current ) )
			return pinned.at( -1 ) === col
		}
		col_resize_right( col: number ) { return this.column_pinned_edge( col ) ? '-7px' : '-2px' }
		pinned_style( col: number ): Record< string, string | number > {
			if( this.data_col_index( col ) < 0 || !this.column_pinned( col ) ) return { position: '', left: '', zIndex: '', background: '', borderRight: '' }
			const pinned = this.col_ids().filter( current => this.data_col_index( current ) >= 0 && this.column_pinned( current ) )
			const left = pinned.filter( before => before < col )
				.reduce( ( sum, before ) => sum + ( this.col_width( before ) || 180 ), 0 )
			return {
				position: 'sticky',
				left: `${ left }px`,
				zIndex: '3',
				background: 'var(--mol_theme_back)',
				borderRight: this.column_pinned_edge( col ) ? '5px solid var(--mol_theme_line)' : 'none',
			}
		}
		cell_style( id: Cell_id ) { return { ...super.cell_style( id ), ...this.pinned_style( id.col ) } }
		@ $mol_mem_key
		Col_head( col: number ) {
			const head = super.Col_head( col ), style = head.style.bind( head ), attr = head.attr.bind( head )
			head.attr = () => ({ ...attr(), pinned: this.column_pinned( col ) })
			head.style = () => ({
				...style(),
				...this.pinned_style( col ),
				zIndex: '',
			})
			return head
		}

		@ $mol_mem
		page_requested( next = 0 ) { return next }

		@ $mol_mem
		page_index( next?: number ) {
			if( next !== undefined ) this.page_requested( Math.max( 0, Math.min( Math.floor( next ), this.page_count() - 1 ) ) )
			return Math.min( this.page_requested(), this.page_count() - 1 )
		}

		page_label() { return `${ this.page_index() + 1 } / ${ this.page_count() }` }

		page_size_selected( next?: string ) {
			if( next !== undefined ) {
				this.table_rows_limit( Number( next ) )
				this.page_index( 0 )
			}
			return String( this.table_rows_limit() )
		}

		page_backward_enabled() { return this.page_index() > 0 }
		page_forward_enabled() { return this.page_index() < this.page_count() - 1 }
		pagination_visible() { return this.fullscreen() ? super.pagination_visible() : [] }

		@ $mol_mem
		Pagination() {
			const pagination = super.Pagination()
			pagination.Backward().enabled = () => this.page_backward_enabled()
			pagination.Forward().enabled = () => this.page_forward_enabled()
			return pagination
		}

		@ $mol_mem
		visible_data_indexes() {
			const head = this.widget().table_head() ?? []
			const hidden = new Set( this.widget().table().cols_hidden() )
			const table = this.widget().table()
			const ordered = [ ...new Set( [ ...table.cols_order(), ...head.map( String ) ] ) ]
			const pinned = table.cols_pinned()
			return ordered.filter( name => pinned.includes( name ) ).concat( ordered.filter( name => !pinned.includes( name ) ) )
				.map( name => head.map( String ).indexOf( name ) ).filter( index => index >= 0 && !hidden.has( String( head[index] ) ) )
		}

		@ $mol_mem
		table_head_rich() {
			const editable = Boolean( this.widget().table().form_custom() )
			const head = this.widget().table_head() ?? []
			const visible = this.visible_data_indexes().map( index => head[ index ] )
			if( this.checkboxes_showed() ) return [ '', '', ...visible, ...( editable ? [ '' ] : [] ) ]
			return [ '', ...visible, ...( editable ? [ '' ] : [] ) ]
		}

		@ $mol_mem
		col_types() {
			const editable = Boolean( this.widget().table().form_custom() )
			const types = this.widget().table_col_types() ?? []
			const visible = this.visible_data_indexes().map( index => types[ index ] )
			if( this.checkboxes_showed() ) return [ 'check', 'index', ...visible, ...( editable ? [ 'action_edit' ] : [] ) ]
			return [ 'index', ...visible, ...( editable ? [ 'action_edit' ] : [] ) ]
		}

		deleting_tool_visible() {
			return this.col_types().includes( 'action_delete' ) ? super.deleting_tool_visible() : []
		}

		add_tools_visible() {
			return this.table_custom()
				? [ this.Add_row(), this.Add_column(), this.Edit_table(), this.Search_toggle() ]
				: []
		}

		column_visibility_options(): string[] {
			return this.widget().table_head().map( String )
		}

		@ $mol_mem
		columns_visible( next?: string[] ): string[] {
			const options = this.column_visibility_options()
			const table = this.widget().table()
			if( next === undefined ) {
				const hidden = new Set( table.cols_hidden() )
				return options.filter( name => !hidden.has( name ) )
			}
			const visible = new Set( next )
			table.cols_hidden( options.filter( name => !visible.has( name ) ) )
			return options.filter( name => visible.has( name ) )
		}

		@ $mol_action
		form_close( row_i: number ) {
			if( row_i < 0 ) this.create_open( false )
			else this.edit_row_index( -1 )
		}

		cell_delete_visible( id: Cell_id ) {
			return this.delete_enabled() ? super.cell_delete_visible(id) : []
		}

		Cell( id: Cell_id ) : $mol_view {

			const col_type = this.col_types()?.[id.col]
			if( col_type == 'check' ) return this.Cell_checkbox( id )
			if( col_type == 'index' ) return this.Cell_index_number( id )
			if( col_type == 'file' ) return this.Cell_file( id )
			if( col_type == 'file_pb' ) return this.Cell_file_pb( id )
			if( col_type == 'atom_link' ) return this.Cell_table_atom_link( id )
			if( col_type == 'list_link' ) return this.Cell_table_list_link( id )
			if( col_type == 'select' ) return this.Cell_table_select( id )
			if( col_type == 'action_delete' ) return this.Cell_delete( id )
			if( col_type == 'action_edit' ) return this.Cell_edit( id )
			if( col_type == 'custom' ) return this.Cell_custom( id )

			return this.Cell_text( id )
		}

		table_relation_name( id: Cell_id ) {
			return this.table_custom()?.field_names()[ this.data_col_index( id.col ) ] ?? ''
		}

		table_relation_dataset_for_name( name: string ) {
			const link = this.widget().table().col_relation_dataset( name )
			if( !link ) return null
			return ( this.map().Datasets()?.remote_list() ?? [] )
				.find( dataset => dataset.link().str === new $giper_baza_link( link ).str ) ?? null
		}

		table_relation_options_for_name( name: string ): Record< string, string > {
			const dataset = this.table_relation_dataset_for_name( name )
			if( !dataset ) return {}
			const selected = this.widget().table().col_relation_display_field( name )
			const display = dataset.fields().find( field => field.link().str === selected )
			return Object.fromEntries( dataset.records().map( record => [
				record.link().toString(), dataset.record_title( record, display ),
			] ) )
		}

		table_select_options_for_name( name: string ) {
			return this.widget().table().col_select_options( name )
		}

		table_select_options( id: Cell_id ) {
			return { '': 'Не выбрано', ...Object.fromEntries( this.table_select_options_for_name( this.table_relation_name( id ) )
				.map( value => [ value, value ] ) ) }
		}

		table_select_value( id: Cell_id, next?: string ) {
			return String( this.table_relation_value( id, next ) ?? '' )
		}

		table_relation_options( id: Cell_id ) {
			return this.table_relation_options_for_name( this.table_relation_name( id ) )
		}

		@ $mol_mem_key
		table_relation_value( id: Cell_id, next?: string | readonly string[] ) {
			const custom = this.table_custom()
			const name = this.table_relation_name( id )
			const index = Number( id.row[ 1 ] )
			if( !custom || !name || !Number.isFinite( index ) ) return ''
			const objects = custom.objects() as Record< string, any >[]
			if( next === undefined ) return objects[ index ]?.[ name ] ?? ''
			if( !objects[ index ] ) return ''
			custom.objects( objects.map( ( object, row ) => row === index ? { ...object, [ name ]: next } : object ) )
			return next
		}

		table_atom_value( id: Cell_id, next?: string ) {
			return String( this.table_relation_value( id, next ) ?? '' )
		}

		table_atom_item_visible( id: Cell_id ) {
			return this.table_atom_value( id ) ? [ this.Table_atom_item( id ) ] : []
		}

		table_atom_label( id: Cell_id ) {
			const link = this.table_atom_value( id )
			return this.table_relation_options( id )[ link ] ?? link
		}

		table_atom_current( id: Cell_id ) {
			return this.table_relation_current( id, this.table_atom_value( id ) )
		}

		@ $mol_action
		table_atom_open( id: Cell_id, next?: Event ) {
			if( next === undefined ) return null
			this.table_relation_open( id, this.table_atom_value( id ) )
			return next
		}

		table_list_value( id: Cell_id, next?: readonly string[] ) {
			const value = this.table_relation_value( id, next )
			return Array.isArray( value ) ? value.map( String ) : []
		}

		override table_list_cell_id( id: Cell_id ) { return id }
		table_list_option_ids( id: Cell_id ) { return Object.keys( this.table_relation_options( id ) ) }

		table_list_picker_value( id: Cell_id, next?: readonly string[] ) {
			const options = this.table_relation_options( id )
			if( next === undefined ) return this.table_list_value( id ).filter( link => link in options )
			const unavailable = this.table_list_value( id ).filter( link => !( link in options ) )
			this.table_list_value( id, [ ...unavailable, ...next ] )
			return next
		}

		table_list_item_key( id: Cell_id, link: string ) {
			return JSON.stringify([ id.row, id.col, link ])
		}
		table_list_item_parts( key: string ) {
			const [ row, col, link ] = JSON.parse( key ) as [ number[], number, string ]
			return { id: { row, col }, link }
		}
		table_list_items( id: Cell_id ) {
			return this.table_list_value( id ).map( link => this.Table_list_item( this.table_list_item_key( id, link ) ) )
		}
		table_list_item_label( key: string ) {
			const { id, link } = this.table_list_item_parts( key )
			return this.table_relation_options( id )[ link ] ?? link
		}
		table_list_item_current( key: string ) {
			const { id, link } = this.table_list_item_parts( key )
			return this.table_relation_current( id, link )
		}
		@ $mol_action
		table_list_item_open( key: string, next?: Event ) {
			if( next === undefined ) return null
			const { id, link } = this.table_list_item_parts( key )
			this.table_relation_open( id, link )
			return next
		}

		table_relation_create_current( id: Cell_id ) {
			if( !this.fullscreen() ) {
				const widget = this.map().Widgets_list()?.remote_list().find( widget => widget.link().str === this.table_relation_edit_widget() )
				return widget?.type() === 'form2' && !widget.Record2()?.remote()
					&& widget.Relation_source_row()?.val() === Number( id.row[ 1 ] )
					&& widget.Relation_source_name()?.val() === this.table_relation_name( id )
			}
			const page = this.table_relation_page_target( 0 )
			return !!page && !page.record && page.legacy_source?.row === Number( id.row[ 1 ] )
				&& page.legacy_source?.name === this.table_relation_name( id )
		}

		@ $mol_mem
		table_relation_pages( next?: readonly Relation_page[] ) {
			return next ?? []
		}

		table_relation_page_index( index: number ) { return index }


		table_relation_page_target( index: number ) {
			return this.table_relation_pages()[ index ] ?? null
		}

		table_relation_edit_target( next?: { dataset: string, record: string } | null ) {
			if( next !== undefined ) this.table_relation_pages( next ? [ next ] : [] )
			return this.table_relation_pages().at( -1 ) ?? null
		}

		@ $mol_mem
		table_relation_edit_widget( next?: string | null ) {
			return next === undefined ? null : next
		}

		table_relation_current( id: Cell_id, link: string ) {
			return this.table_relation_current_name( this.table_relation_name( id ), link )
		}

		table_relation_current_name( name: string, link: string ) {
			const target = this.table_relation_edit_target()
			if( !target || !link || new $giper_baza_link( target.record ).str !== new $giper_baza_link( link ).str ) return false
			if( this.table_relation_dataset_for_name( name )?.link().str !== new $giper_baza_link( target.dataset ).str ) return false
			const opened = this.table_relation_edit_widget()
			return this.fullscreen() || !!opened && !!this.map().Widgets_list()?.remote_list().some( widget => widget.link().str === opened )
		}

		table_form_relation_active( name: string ) {
			const target = this.table_relation_edit_target()
			return target && this.table_relation_dataset_for_name( name )?.link().str === new $giper_baza_link( target.dataset ).str
				? target.record : ''
		}

		@ $mol_action
		table_form_relation_open( name: string, link: string ) {
			this.table_relation_open_name( name, link )
		}

		@ $mol_action
		table_form_relation_create( name: string ) {
			const row = this.edit_row_index()
			if( row < 0 ) {
				$shm_hitalama_notifications.warning( 'Сначала сохраните строку таблицы' )
				return
			}
			this.table_relation_create_name( name, row )
		}

		@ $mol_action
		table_relation_create( id: Cell_id, event?: Event ) {
			if( event === undefined ) return null
			this.table_relation_create_name( this.table_relation_name( id ), Number( id.row[ 1 ] ) )
			return event
		}

		@ $mol_action
		table_relation_create_name( name: string, row: number ) {
			const dataset = this.table_relation_dataset_for_name( name )
			if( !dataset ) {
				$shm_hitalama_notifications.warning( 'Сначала выберите связанную таблицу' )
				return
			}
			this.table_relation_close()
			if( this.fullscreen() ) {
				this.create_open( false )
				this.table_editing( false )
				this.column_editor_col( -1 )
				dataset.draft_reset()
				this.table_relation_create_source({ name, row })
				this.table_relation_pages([ { dataset: dataset.link().str, record: '',
					legacy_source: { table: this.widget().table().link().str, row, name },
					parent_label: String( this.table_custom()?.objects()[ row ]?.[ this.table_custom()?.field_names()[0] ?? '' ] ?? '' ) } ])
				return
			}
			const widget = this.map().widget_add( 'form2',
				[ this.widget().body_x() + this.widget().right_edge_x(), this.widget().body_y() ], 450, 780 )!
			widget.title( 'Новая запись' )
			widget.Dataset( null )?.val( new $giper_baza_link( dataset.link().str ) )
			widget.Relation_source_table( null )?.val( new $giper_baza_link( this.widget().table().link().str ) )
			widget.Relation_source_row( null )?.val( row )
			widget.Relation_source_name( null )?.val( name )
			this.table_relation_edit_widget( widget.link().str )
			this.Map_page().contextmenu_showed( false )
		}

		@ $mol_mem
		table_relation_create_source( next?: { name: string, row: number } | null ) {
			return next === undefined ? null : next
		}

		@ $mol_action
		table_relation_create_submit( object: Record< string, any > ) {
			const source = this.table_relation_create_source()
			const dataset = this.table_relation_edit_dataset()
			const custom = this.table_custom()
			if( !source || !dataset || !custom ) return null
			const objects = [ ...custom.objects() ] as Record< string, any >[]
			const row = objects[ source.row ]
			if( !row ) return null
			const created = dataset.record_add( object )
			const current = row[ source.name ]
			objects[ source.row ] = { ...row, [ source.name ]: custom.field_type( source.name ) === 'list_link'
				? [ ...new Set([ ...( Array.isArray( current ) ? current : [] ), created.link().str ]) ] : created.link().str }
			custom.objects( objects )
			dataset.draft_reset()
			return created
		}

		table_relation_edit_dataset() {
			const target = this.table_relation_edit_target()
			return target ? ( this.map().Datasets()?.remote_list() ?? [] )
				.find( dataset => dataset.link().str === new $giper_baza_link( target.dataset ).str ) ?? null : null
		}

		table_relation_edit_record() {
			const target = this.table_relation_edit_target()
			const dataset = this.table_relation_edit_dataset()
			return target?.record && dataset ? dataset.records().find( record => record.link().str === new $giper_baza_link( target.record ).str ) ?? null : null
		}

		table_relation_page_dataset( index: number ) {
			const target = this.table_relation_page_target( index )
			return target ? ( this.map().Datasets()?.remote_list() ?? [] )
				.find( dataset => dataset.link().str === new $giper_baza_link( target.dataset ).str ) ?? null : null
		}

		table_relation_page_record( index: number ) {
			const target = this.table_relation_page_target( index )
			const dataset = this.table_relation_page_dataset( index )
			return target?.record && dataset ? dataset.records().find( record => record.link().str === new $giper_baza_link( target.record ).str ) ?? null : null
		}

		table_relation_page_row_index( index: number ) {
			const record = this.table_relation_page_record( index )
			return record ? this.table_relation_page_dataset( index )!.records().indexOf( record ) : -1
		}

		table_relation_page_title( index: number ) {
			const page = this.table_relation_page_target( index )
			const dataset = this.table_relation_page_dataset( index )
			const title = this.related_table_title( dataset )
			return page?.parent_label ? `${ title } - ${ page.parent_label }` : title
		}

		table_relation_page_data_value( index: number, name: string, next?: any ) {
			const page = this.table_relation_page_target( index )
			const dataset = this.table_relation_page_dataset( index )
			const field = dataset?.field( name )
			const record = this.table_relation_page_record( index )
			if( !field || !dataset ) return ''
			if( !record && page && !page.record ) return dataset.object_current_value( name, next )
			if( !record ) return ''
			if( next === undefined ) return record.value( field )
			const value = field.type() === 'date' && next
				? new $mol_time_moment( next ).toString( 'DD.MM.YYYY' ) : next
			record.value( field, value )
			return next
		}

		@ $mol_action
		table_relation_create_record( index: number, field: $shm_hitalama_map_widget_entity_table2_field, record: $shm_hitalama_map_widget_entity_table2_record ) {
			const target = field.target_dataset()
			const source = this.table_relation_page_dataset( index )
			if( !target || !source ) {
				$shm_hitalama_notifications.warning( 'Сначала выберите связанную таблицу' )
				return
			}
			target.draft_reset()
			this.table_relation_pages([ ... this.table_relation_pages().slice( 0, index + 1 ), {
				dataset: target.link().str,
				record: '',
				parent_label: this.record_first_label( source, record ),
				source: { dataset: source.link().str, field: field.link().str, record: record.link().str },
			} ])
		}

		@ $mol_action
		table_relation_create_record_submit( index: number, object: Record< string, any > ) {
			const page = this.table_relation_page_target( index )
			const target = this.table_relation_page_dataset( index )
			const source = page?.source
			const source_dataset = ( this.map().Datasets()?.remote_list() ?? [] )
				.find( dataset => dataset.link().str === source?.dataset )
			const field = source_dataset?.fields().find( field => field.link().str === source?.field )
			const record = source_dataset?.records().find( record => record.link().str === source?.record )
			if( !target || !field || !record ) return null
			const created = target.record_add( object )
			const current = record.value( field )
			record.value( field, field.type() === 'list_link'
				? [ ...new Set([ ...( Array.isArray( current ) ? current : [] ), created.link().str ]) ]
				: created.link().str )
			target.draft_reset()
			return created
		}

		@ $mol_action
		table_relation_close_at( index: number ) {
			this.table_relation_pages( this.table_relation_pages().slice( 0, index ) )
			if( index === 0 ) this.table_relation_create_source( null )
		}

		@ $mol_action
		table_relation_close() {
			const opened = this.table_relation_edit_widget()
			if( opened ) {
				const widget = this.map().Widgets_list()?.remote_list().find( widget => widget.link().str === opened )
				if( widget ) this.map().widget_cut( widget.link() )
			}
			this.table_relation_edit_widget( null )
			this.table_relation_edit_target( null )
			this.table_relation_create_source( null )
		}

		@ $mol_action
		table_relation_open( id: Cell_id, link: string ) {
			this.table_relation_open_name( this.table_relation_name( id ), link, Number( id.row[ 1 ] ) )
		}

		@ $mol_action
		table_relation_open_name( name: string, link: string, row = this.edit_row_index() ) {
			this.table_relation_open_dataset( this.table_relation_dataset_for_name( name ), link, undefined,
				String( this.table_custom()?.objects()[ row ]?.[ this.table_custom()?.field_names()[0] ?? '' ] ?? '' ) )
		}

		@ $mol_action
		table_relation_open_field( field: $shm_hitalama_map_widget_entity_table2_field | null, link: string, from?: number ) {
			const source = from === undefined ? null : this.table_relation_page_record( from )
			this.table_relation_open_dataset( field?.target_dataset() ?? null, link, from,
				source && from !== undefined ? this.record_first_label( this.table_relation_page_dataset( from ), source ) : '' )
		}

		@ $mol_action
		table_relation_open_dataset( dataset: $shm_hitalama_map_widget_entity_table2_dataset | null, link: string,
			from?: number, parent_label = '' ) {
			if( !link ) return
			const current = from === undefined ? this.table_relation_edit_target() : this.table_relation_page_target( from + 1 )
			const opened = this.table_relation_edit_widget()
			if( current && dataset && new $giper_baza_link( current.dataset ).str === dataset.link().str
				&& new $giper_baza_link( current.record ).str === new $giper_baza_link( link ).str
				&& ( this.fullscreen() || !!opened && !!this.map().Widgets_list()?.remote_list().some( widget => widget.link().str === opened ) ) ) {
				if( from === undefined ) this.table_relation_close()
				else this.table_relation_close_at( from + 1 )
				return
			}
			const record = dataset?.records().find( record => record.link().str === new $giper_baza_link( link ).str )
			if( !dataset || !record ) {
				$shm_hitalama_notifications.warning( 'Связанная запись не найдена' )
				return
			}
			if( this.fullscreen() ) {
				if( from === undefined ) {
					this.table_relation_close()
					this.create_open( false )
					this.table_editing( false )
					this.column_editor_col( -1 )
					// Keep the row form open under the related form stack.
				}
				const pages = from === undefined ? [] : this.table_relation_pages().slice( 0, from + 1 )
				this.table_relation_pages([ ...pages, { dataset: dataset.link().str, record: record.link().str, parent_label } ])
				return
			}
			this.table_relation_close()
			const widget = this.map().widget_add(
				'form2', [ this.widget().body_x() + this.widget().right_edge_x(), this.widget().body_y() ], 450, 780,
			)!
			widget.title( dataset.record_title( record ) )
			widget.Dataset( null )?.val( new $giper_baza_link( dataset.link().str ) )
			widget.Record2( null )?.val( new $giper_baza_link( record.link().str ) )
			this.table_relation_edit_target({ dataset: dataset.link().toString(), record: record.link().toString() })
			this.table_relation_edit_widget( widget.link().str )
			this.Map_page().contextmenu_showed( false )
		}

		col_ids() {
			return this.table_head_rich().map( (_,i) => i )
		}
		
		col_head_content( n: number ) {
			const col_type = this.col_types()?.[n]
			if( col_type == 'check' ) return [ this.All_check() ]
			if( col_type == 'index' && this.table_custom() ) return [ this.Add() ]
			if( this.data_col_index( n ) >= 0 ) return [ this.Col_head_content( n ), this.Col_resize( n ) ]
			return [ this.table_head_rich()?.[n] || '' ]
		}

		data_col_index( col: number ) {
			const visible_index = col - ( this.checkboxes_showed() ? 2 : 1 )
			return this.visible_data_indexes()[ visible_index ] ?? -1
		}

		@ $mol_mem_key
		col_name_draft_for( name: string, next?: string ) {
			$mol_wire_solid()
			return next ?? name
		}
		col_name_draft( col: number, next?: string ) { return this.col_name_draft_for( this.col_settings_title( col ), next ) }

		@ $mol_action
		col_name_commit( col: number, next?: Event ) {
			if( !next ) return null
			const index = this.data_col_index( col )
			const custom = this.table_custom()
			if( index < 0 || !custom ) return next

			const old_name = custom.field_names()[ index ]
			const new_name = this.col_name_draft( col ).trim()
			if( !new_name || new_name === old_name ) {
				this.col_name_draft( col, old_name )
				return next
			}
			if( custom.field_names().includes( new_name ) ) {
				this.col_name_draft( col, old_name )
				$shm_hitalama_notifications.warning( `Поле «${ new_name }» уже существует` )
				return next
			}

			const owner = custom.widget_with_fields()
			if( !owner || owner.Data_method()?.val() ) {
				this.col_name_draft( col, old_name )
				$shm_hitalama_notifications.warning( 'Нельзя переименовать вычисляемый набор полей' )
				return next
			}

			const rename = ( record: Record< string, any > )=> {
				if( !Object.prototype.hasOwnProperty.call( record, old_name ) ) return record
				const result: Record< string, any > = {}
				for( const key of Object.keys( record ) ) result[ key === old_name ? new_name : key ] = record[ key ]
				return result
			}
			const source = String( custom.text() )
			const renamed = source.split( /(\r?\n|\|)/ ).map( part => {
				if( part === '|' || /^\r?\n$/.test( part ) ) return part
				const parsed = custom.field_parse( part.trim() )
				if( parsed.name !== old_name ) return part
				const lead = part.match( /^\s*/ )?.[0] ?? ''
				const tail = part.match( /\s*$/ )?.[0] ?? ''
				return `${ lead }${ new_name }${ parsed.required ? '*' : '' }${ parsed.tags.length ? ` ${ parsed.tags.join( ' ' ) }` : '' }${ tail }`
			} ).join( '' )

			custom.objects( custom.objects().map( record => rename( record as Record< string, any > ) ) )
			custom.object_current( rename( custom.object_current() ) )
			this.create_record( rename( this.create_record() ) )
			this.edit_record( rename( this.edit_record() ) )
			const codes = this.widget().table().col_custom_codes()
			if( Object.prototype.hasOwnProperty.call( codes, old_name ) ) {
				const codes_next: Record< string, string > = { ...codes, [ new_name ]: codes[ old_name ] }
				delete codes_next[ old_name ]
				this.widget().table().col_custom_codes( codes_next )
			}
			const hidden = this.widget().table().cols_hidden()
			if( hidden.includes( old_name ) ) {
				this.widget().table().cols_hidden( hidden.map( name => name === old_name ? new_name : name ) )
			}
			const table = this.widget().table()
			const selects = ( table.Col_select_options()?.val() ?? {} ) as Record< string, string[] >
			if( Object.prototype.hasOwnProperty.call( selects, old_name ) ) {
				const updated = { ...selects, [ new_name ]: selects[ old_name ] }
				delete updated[ old_name ]
				table.Col_select_options( null )!.val( updated )
			}
			table.cols_order( table.cols_order().map( name => name === old_name ? new_name : name ) )
			table.cols_pinned( table.cols_pinned().map( name => name === old_name ? new_name : name ) )
			const filter = this.filter_by_name( old_name ), renamed_filter = this.filter_by_name( new_name )
			renamed_filter.mode( filter.mode() )
			renamed_filter.value( filter.value() )
			renamed_filter.until( filter.until() )
			filter.mode( 'all' )
			if( this.sort_state().name === old_name ) this.sort_state({ ...this.sort_state(), name: new_name })
			this.col_name_draft( col, new_name )
			this.col_name_draft_for( new_name, new_name )
			if( next.type !== 'blur' ) this.Col_settings( col ).showed( false )
			$shm_hitalama_notifications.success( `Столбец переименован в «${ new_name }»` )
			if( owner.data() !== undefined ) owner.data( renamed )
			else owner.text( renamed )
			return next
		}

		col_type_options() {
			return {
				any: 'Обычный',
				string: 'Строка',
				number: 'Число',
				textarea: 'Многострочный текст',
				date: 'Дата',
				period: 'Период',
				file: 'Файл карты',
				file_pb: 'Файл PocketBase',
				json: 'JSON',
				atom_link: 'Ссылка',
				list_link: 'Список ссылок',
				select: 'Выбор из списка',
				custom: 'Пользовательский код',
			}
		}

		select_options_visible( col: number ) {
			return this.col_type( col ) === 'select' ? [ this.Select_options_label( col ) ] : []
		}

		@ $mol_mem_key
		select_options_draft( col: number, next?: string ) {
			return next ?? ''
		}

		@ $mol_mem_key
		select_options_editing( col: number, next?: boolean ) {
			return next ?? false
		}

		select_options_saved( col: number ) {
			const name = this.table_custom()?.field_names()[ this.data_col_index( col ) ]
			return name ? this.widget().table().col_select_options( name ).join( '\n' ) : ''
		}

		select_options( col: number, next?: string ) {
			const name = this.table_custom()?.field_names()[ this.data_col_index( col ) ]
			if( !name ) return ''
			const table = this.widget().table()
			if( next !== undefined ) {
				this.select_options_draft( col, next )
				this.select_options_editing( col, true )
				table.col_select_options( name, [ ...new Set( next.split( '\n' ).map( value => value.trim() ).filter( Boolean ) ) ] )
			}
			return this.select_options_editing( col ) ? this.select_options_draft( col ) : this.select_options_saved( col )
		}

		relation_dataset_visible( col: number ) {
			return [ 'atom_link', 'list_link' ].includes( this.col_type( col ) )
				? [ this.Relation_dataset_label( col ) ] : []
		}

		relation_dataset_options(): Record< string, string > {
			const widgets = this.map().Widgets_list()?.remote_list() ?? []
			return Object.fromEntries( widgets.filter( widget => widget.type() === 'table2' ).map( widget => [
				widget.dataset().link().toString(), widget.title(),
			] ) )
		}

		relation_dataset( col: number, next?: string ) {
			const index = this.data_col_index( col )
			const name = this.table_custom()?.field_names()[ index ]
			if( !name ) return ''
			if( next === undefined ) return this.widget().table().col_relation_dataset( name )
			const valid = next && Object.prototype.hasOwnProperty.call( this.relation_dataset_options(), next ) ? next : ''
			return this.widget().table().col_relation_dataset( name, valid )
		}

		relation_display_visible( col: number ) {
			return this.relation_dataset( col ) ? [ this.Relation_display_label( col ) ] : []
		}

		relation_display_options( col: number ) {
			const name = this.table_custom()?.field_names()[ this.data_col_index( col ) ] ?? ''
			const dataset = this.table_relation_dataset_for_name( name )
			return {
				'': 'Первый подходящий',
				...Object.fromEntries( ( dataset?.fields() ?? [] )
					.filter( field => field.type() !== 'atom_link' && field.type() !== 'list_link' )
					.map( field => [ field.link().toString(), field.title() ] ) ),
			}
		}

		relation_display( col: number, next?: string ) {
			const name = this.table_custom()?.field_names()[ this.data_col_index( col ) ] ?? ''
			if( !name ) return ''
			if( next === undefined ) return this.widget().table().col_relation_display_field( name )
			const valid = Object.prototype.hasOwnProperty.call( this.relation_display_options( col ), next ) ? next : ''
			return this.widget().table().col_relation_display_field( name, valid )
		}

		@ $mol_mem_key
		col_type( col: number, next?: string ) {
			const index = this.data_col_index( col )
			const custom = this.table_custom()
			if( index < 0 || !custom ) return 'any'
			const name = custom.field_names()[ index ]
			const current = custom.field_type( name ) ?? 'any'
			if( next === undefined || next === current ) return current
			if( !Object.prototype.hasOwnProperty.call( this.col_type_options(), next ) ) return current
			if( !custom.fields_mutable() || !custom.field_type_set( name, next as Parameters< typeof custom.field_type_set >[ 1 ] ) ) {
				$shm_hitalama_notifications.warning( 'Нельзя изменить вычисляемый набор полей' )
				return current
			}
			$shm_hitalama_notifications.success( `Тип столбца «${ name }» изменён` )
			this.filter_by_name( name ).mode( 'all' )
			return next
		}

		custom_code_visible( col: number ) {
			if( this.col_type( col ) !== 'custom' ) return []
			return this.fullscreen() ? [ this.Col_code_open( col ) ] : [ this.Col_custom_code_label( col ) ]
		}

		@ $mol_action
		column_editor_close( next?: Event ) {
			if( next ) this.column_editor_col( -1 )
			return next ?? null
		}

		@ $mol_action
		column_editor_open( col: number, next?: Event ) {
			if( !next ) return null
			this.column_editor_fullscreen( false )
			this.Col_settings( col ).showed( false )
			this.edit_row_index( -1 )
			this.table_editing( false )
			this.column_editor_col( col )
			return next
		}

		col_custom_code_help() {
			const args = [ 'table', 'row', 'row_index', 'column', 'value', 'widget', 'view', 'cell_id' ]
				.map( name => '$' + name ).join( ', ' )
			return `Код должен вернуть текст, компонент или массив. Доступны: ${ args }.`
		}

		@ $mol_mem_key
		col_custom_code( col: number, next?: string ) {
			const index = this.data_col_index( col )
			const name = this.table_custom()?.field_names()[ index ]
			if( !name ) return ''
			return this.widget().table().col_custom_code( name, next )
		}

		@ $mol_action
		add_column( next?: Event ) {
			if( next === undefined ) return null
			this.add_column_lock().grab()
			const custom = this.table_custom()
			if( !custom || !custom.fields_mutable() ) {
				$shm_hitalama_notifications.warning( 'Нельзя изменить вычисляемый набор полей' )
				return next
			}

			const name = this.add_column_name()
			if( !custom.field_add( name ) ) return next

			const defaults = this.add_column_defaults( name )
			custom.objects( defaults.objects )
			custom.object_current( defaults.current )
			this.create_record( defaults.create )
			this.edit_record( defaults.edit )
			$shm_hitalama_notifications.success( `Добавлен столбец «${ name }»` )
			return next
		}

		// Nested one-shot tasks retain the chosen name and write arguments on suspension.
		@ $mol_mem
		add_column_lock() {
			return new $mol_lock
		}

		@ $mol_action
		add_column_name() {
			const names = new Set( this.table_custom()!.field_names() )
			let number = 1
			while( names.has( `Столбец_${ number }` ) ) ++ number
			return `Столбец_${ number }`
		}

		@ $mol_action
		add_column_defaults( name: string ) {
			const custom = this.table_custom()!
			const extend = ( record: Record< string, any > )=> ({ ...record, [ name ]: '' })
			return {
				objects: custom.objects().map( record => extend( record as Record< string, any > ) ),
				current: extend( custom.object_current() ),
				create: extend( this.create_record() ),
				edit: extend( this.edit_record() ),
			}
		}

		@ $mol_mem_key
		col_delete_asked( col: number, next?: boolean ) {
			return next ?? false
		}

		@ $mol_action
		col_delete_ask( col: number, next?: Event ) {
			if( next === undefined ) return null
			this.col_delete_asked( col, true )
			return next
		}

		col_delete_confirm_visible( col: number ) {
			return this.col_delete_asked( col )
				? [ this.Delete_column_confirm( col ), this.Delete_column_cancel( col ) ]
				: []
		}

		@ $mol_action
		col_delete_cancel( col: number, next?: Event ) {
			if( next === undefined ) return null
			this.col_delete_asked( col, false )
			return next
		}

		@ $mol_action
		col_delete( col: number, next?: Event ) {
			if( next === undefined ) return null
			this.column_editor_col( -1 )
			const index = this.data_col_index( col )
			const custom = this.table_custom()
			if( index < 0 || !custom || !custom.fields_mutable() ) {
				$shm_hitalama_notifications.warning( 'Нельзя изменить вычисляемый набор полей' )
				return next
			}

			const name = custom.field_names()[ index ]
			if( !custom.field_remove( name ) ) return next
			const without = ( record: Record< string, any > )=> Object.fromEntries(
				Object.entries( record ).filter( ([ key ])=> key !== name ),
			)
			custom.objects( custom.objects().map( record => without( record as Record< string, any > ) ) )
			custom.object_current( without( custom.object_current() ) )
			this.create_record( without( this.create_record() ) )
			this.edit_record( without( this.edit_record() ) )

			const codes = { ...this.widget().table().col_custom_codes() }
			delete codes[ name ]
			this.widget().table().col_custom_codes( codes )
			const selects = { ... ( this.widget().table().Col_select_options()?.val() ?? {} ) } as Record< string, string[] >
			delete selects[ name ]
			this.widget().table().Col_select_options( null )!.val( selects )
			this.widget().table().cols_hidden( this.widget().table().cols_hidden().filter( hidden => hidden !== name ) )
			this.widget().table().cols_order( this.widget().table().cols_order().filter( value => value !== name ) )
			this.widget().table().cols_pinned( this.widget().table().cols_pinned().filter( value => value !== name ) )
			this.filter_by_name( name ).mode( 'all' )
			if( this.sort_state().name === name ) this.sort_state({ name: '', direction: 'none' })
			const widths = [ ...( this.widget().table().Col_widths()?.val() as readonly number[] ?? [] ) ]
			widths.splice( index + 1, 1 )
			this.widget().table().Col_widths()?.val( widths )
			this.col_delete_asked( col, false )
			this.Col_settings( col ).showed( false )
			$shm_hitalama_notifications.success( `Удалён столбец «${ name }»` )
			return next
		}

		@ $mol_mem_key
		custom_cell_content( id: Cell_id ) {
			const data_index = this.data_col_index( id.col )
			const custom = this.table_custom()
			const column = custom?.field_names()[ data_index ]
			const row_index = Number( id.row[ 1 ] )
			if( !custom || !column || !Number.isFinite( row_index ) ) return []

			const row = custom.objects()[ row_index ] as Record< string, any > ?? {}
			const value = row[ column ]
			const code = this.col_custom_code( id.col ).trim()
			if( !code ) return [ value ?? '' ]

			const result = this.$.$mol_error_fence(
				()=> this.map().execute( code, {
					[ '$' + 'table' ]: this.widget().table(),
					[ '$' + 'row' ]: row,
					[ '$' + 'row_index' ]: row_index,
					[ '$' + 'column' ]: column,
					[ '$' + 'value' ]: value,
					[ '$' + 'widget' ]: this.widget(),
					[ '$' + 'view' ]: this,
					[ '$' + 'cell_id' ]: id,
				} ),
				error => `Ошибка: ${ error instanceof Error ? error.message : String( error ) }`,
			)
			if( this.$.$mol_promise_like( result ) ) throw result
			return Array.isArray( result ) ? result : [ result ?? '' ]
		}

		col_head_padding( n: number ) {
			return this.col_types()?.[ n ] === 'index' && this.table_custom()
				? '0'
				: 'var(--mol_gap_text)'
		}

		add_active() {
			return this.fullscreen() && this.create_open()
		}

		@ $mol_mem_key
		action_edit_active( id: Cell_id ) {
			return this.fullscreen() && this.edit_row_index() === Number( id.row[1] )
		}

		@ $mol_action
		add() {
			this.table_editing( false )
			if( this.fullscreen() ) {
				if( this.create_open() ) {
					this.create_open( false )
					return
				}
				this.create_record( {} )
				this.create_open( true )
				return
			}

			const custom = this.table_custom()
			const form = this.map().Widgets_list()?.remote_list().find( widget => {
				if( widget.type() !== 'form_custom' ) return false
				return widget.Form_custom()?.remote()?.link().str === custom?.link().str
			} )

			if( !form ) {
				$shm_hitalama_notifications.warning( 'Связанная форма не найдена на карте' )
				return
			}

			this.Map_page().go_to_widget( form.link() )
		}

		@ $mol_action
		record_edit_complete( row_i: number ) {
			const message = `Обновлена строка №${ row_i + 1 }`
			this.edit_row_index( -1 )
			$shm_hitalama_notifications.success( message )
		}

		@ $mol_action
		record_submit( row_i: number, object: Record< string, any > ) {
			const custom = this.table_custom()!
			const objects = [ ... custom.objects() ]
			let message = ''

			if( row_i < 0 ) {
				objects.push( object )
				message = `Создана запись №${ objects.length }`
			} else {
				objects[ row_i ] = object
				message = `Обновлена строка №${ row_i + 1 }`
			}

			custom.objects( objects )
			if( row_i >= 0 ) this.edit_row_index( -1 )
			$shm_hitalama_notifications.success( message )
			return message
		}

		col_settings_title( n: number ) {
			return this.table_head_rich()?.[n] || this.col_types()?.[n] || ''
		}

		@ $mol_mem_key
		cell_index_number( id: Cell_id ) {
			return ( Number( id.row[1]! ) + 1 ).toString()
		}

		@ $mol_mem_key
		cell_content_text_str( id: Cell_id ) {
			return this.cell_content_text( id ).toString()
		}

		@ $mol_mem_key
		cell_file_name( id: Cell_id ) {
			const ref_str = this.cell_content_text_str( id )
			const file = $giper_baza_glob.Pawn( new $giper_baza_link( ref_str ), $shm_hitalama_file )
			return file.title()
		}

		@ $mol_mem_key
		cell_file_visible( id: Cell_id ) {
			const ref_str = this.cell_content_text_str( id )
			return ref_str ? super.cell_file_visible( id ) : []
		}

		@ $mol_mem_key
		file_uri_async( ref_str: string ) {
			const file = $giper_baza_glob.Pawn( new $giper_baza_link( ref_str ), $shm_hitalama_file )
			const blob = file.blob()!
			return this.$.$mol_blob_uri( blob )
		}

		@ $mol_action
		file_uri( ref_str: string ) {
			return this.$.$mol_wire_sync(this).file_uri_async( ref_str )
		}

		@ $mol_mem_key
		cell_file_uri( id: Cell_id ) {
			const ref_str = this.cell_content_text_str( id )
			const uri = this.file_uri( ref_str )
			return uri
		}
		@ $mol_mem_key
		cell_file_pb_uri( id: Cell_id ) {
			const parsed = this.$.$shm_hitalama_file_attach_pb_store.value_parse( this.cell_content_text_str( id ) )
			if( !parsed ) return ''
			parsed.uri.hash = ''
			return parsed.uri.toString()
		}
		@ $mol_mem_key
		cell_file_pb_name( id: Cell_id ) {
			const uri = this.cell_file_pb_uri( id )
			return uri ? decodeURIComponent( new URL( uri ).pathname.split( '/' ).at( -1 ) ?? '' ) : ''
		}
		@ $mol_mem_key
		cell_file_pb_visible( id: Cell_id ) { return this.cell_file_pb_uri( id ) ? super.cell_file_pb_visible( id ) : [] }

		@ $mol_mem_key
		cell_checked( id: Cell_id, next?: boolean ) {
			const checks = this.widget().table().Rows_checked()?.val() as Record< number, boolean >
			const row_i = id.row[1]!
			if( next === undefined ) return  checks?.[ row_i ] ?? false

			this.widget().table().Rows_checked(null)?.val( { 
				... checks,
				[row_i]: next,
			} )
			return next
		}

		@ $mol_action
		cell_delete( id: Cell_id ) {
			const row_i = id.row[1]!
			this.map().search_statistics_cut( row_i )

			const rows_checked = this.widget().table().Rows_checked()?.val() as Record< number, boolean > ?? {}
			const rows_checked_next: Record< number, boolean > = {}

			for (const key in rows_checked) {
				let n = Number(key)
				const bool = rows_checked[n]
				if( n > row_i ) n--
				rows_checked_next[n] = bool
			}

			this.widget().table().Rows_checked()?.val(rows_checked_next)
		}

		@ $mol_action
		cell_edit( id: Cell_id ) {
			const row_i = Number( id.row[1] )
			return $mol_wire_async( this ).cell_edit_later( row_i ).catch( $mol_fail_log )
		}

		@ $mol_action
		cell_edit_later( row_i: number ) {
			this.selected_row( row_i )
			const custom = this.widget().table().form_custom()
			if( custom ) {
				if( this.fullscreen() ) {
					this.table_editing( false )
					this.column_editor_col( -1 )
					if( this.edit_row_index() === row_i ) {
						this.edit_row_index( -1 )
						return
					}
					const record = custom.objects()[ row_i ] as Record< string, any >
					this.edit_record({ ... record })
					this.edit_row_index( row_i )
					return
				}
				return this.cell_edit_custom_open( row_i )
			}
			const statistic = this.map().Search_statistics()?.remote_list().at( row_i )

			const pos = [
				this.widget().body_x() + this.widget().right_edge_x(),
				this.widget().body_y(),
			]

			const widget = this.map().widget_add( 'form_edit', pos, 450, 780 )
			widget?.Form_edit(null)?.remote( statistic )

			this.Map_page().contextmenu_showed( false )
		}

		@ $mol_mem_key
		cell_edit_custom_widget( row_i: number ) {
			return this.map().widget_add( 'form_custom', [ this.widget().body_x() + this.widget().right_edge_x(), this.widget().body_y() ], 450, 780 )!
		}

		@ $mol_action
		cell_edit_custom_open( row_i: number ) {
			const widget = this.cell_edit_custom_widget( row_i )
			const custom = this.widget().table().form_custom()!
			widget.title( `Строка ${ row_i + 1 }` )
			widget.Data_method(null)?.val(`
					const index = ${ row_i }
					const form = $${''}this_widget.form_custom()
					const objects = form.objects()
					if( next === undefined ) return objects[ index ] ?? {}
					const updated = [ ... objects ]
					updated[ index ] = next
					form.objects( updated )
					return next
				`)
			widget.Form_custom(null)?.remote( custom )
			widget.Source_table(null)?.remote( this.widget().table() )
			this.Map_page().contextmenu_showed( false )
		}

		cell_checkboxes() {
			const checkboxes = this.table_row_ids().map( row => this.Checkbox( { col: '0', row } ) )
			return checkboxes
		}

		@ $mol_mem_key
		col_width_px( id: any ) {
			const width = Number( this.col_width( id.col ) )
			return isNaN( width ) ? 'auto' : width + 'px'
		}

		col_head_width( col: number ) {
			if( [ 'check', 'index' ].includes( String( this.col_types()[col] ) ) ) return '40px'
			const width = this.col_width( col )
			return Number.isFinite( width ) ? width + 'px' : 'auto'
		}

		@ $mol_mem_key
		col_width( col: any, next?: number ): number {
			const visual_index = Number( col )
			const data_index = this.data_col_index( visual_index )
			if( data_index < 0 ) return NaN
			const col_index = data_index + 1
			const widths = this.widget().table()?.Col_widths()?.val() as readonly number[] | undefined
			if( next === undefined ) {
				const width = widths?.[col_index] ?? NaN
				return Number.isFinite( width ) ? Math.min( 600, Math.max( 0, width ) ) : NaN
			}
			next = Number.isFinite( next ) ? Math.min( 600, Math.max( 0, next ) ) : next

			const widths_next = [ ... widths??[] ]
			widths_next[col_index] = next
			this.widget().table()?.Col_widths(null)?.val( widths_next )

			return next ?? NaN
		}

		@ $mol_mem
		col_width_rows() {
			return this.col_types()
				.map( ( _, col )=> col )
				.filter( col => this.data_col_index( col ) >= 0 )
				.map( col => this.Col_width_row( col ) )
		}

		@ $mol_action
		chart_add() {
			const chart_pos = this.Map_page().contextmenu_real_pos()
			const chart_widget = this.map().widget_add( 'chart', chart_pos, 600, 400 )
			chart_widget?.Table(null)?.remote( this.widget().table() )
			const chart = chart_widget?.chart()
			chart?.Widget(null)?.remote( chart_widget )

			chart_widget?.settings_widget_enabled( true )

			this.Map_page().contextmenu_showed( false )
		}

		@ $mol_action
		tabulator_add() {
			const pos = this.Map_page().contextmenu_real_pos()
			const widget = this.map().widget_add( 'tabulator', pos, 720, 420 )
			widget?.Table(null)?.remote( this.widget().table() )

			this.Map_page().contextmenu_showed( false )
		}

		@ $mol_action
		echarts_add() {
			const pos = this.Map_page().contextmenu_real_pos()
			const widget = this.map().widget_add( 'echarts', pos, 650, 460 )
			widget?.Table(null)?.remote( this.widget().table() )

			const chart = widget?.chart()
			chart?.Widget(null)?.remote( widget )

			widget?.settings_widget_enabled( true )

			this.Map_page().contextmenu_showed( false )
		}
		
	}

}
